var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkInterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 249.27 193.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#ece70d;stroke-width:2px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke:url(#linear-gradient);}.cls-2,.cls-3,.cls-4{stroke-width:4px;}.cls-3{stroke:url(#linear-gradient-3);}.cls-5{fill:#e6e6e6;}.cls-5,.cls-6{stroke:#218cff;stroke-miterlimit:10;stroke-width:1.17px;}.cls-4{stroke:url(#linear-gradient-2);}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 144.31,
    y1: 61.97,
    x2: 157.97,
    y2: 61.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 159.37,
    y1: 61.72,
    x2: 173.94,
    y2: 61.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 128.34,
    y1: 61.72,
    x2: 142.91,
    y2: 61.72,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.43,127.24c-.05-.01,.03,0,.03,0,4.5-11.38,13.76-20.36,13.58-33.37-.36-25.88-20.61-46.21-46.57-46.57-17.55-.24-32.63,8.23-40.88,23.52,.02,.12,0,.05,0,.06-1.75,4.3-4.39,8.1-4.97,12.83-.66,5.46,2.41,10.88,2.11,16.33-.3,5.46-3.8,9.28-6.93,13.42-1.38,1.82-3.21,3.33-3.22,5.74,0,1.8,1.21,3.08,2.66,3.98,1.45,.9,3.16,1.1,4.8,1.47,.59,1.39,1.04,2.81,.7,4.3-.2,.86-.69,1.48-.69,2.36,0,1.57,.95,2.62,2.29,3.34,.31,.17,.63,.22,.95,.33-.21,.44-.58,1.02-.74,1.44-.67,1.73-.11,3.2,.77,4.68,.88,1.48,2.05,2.58,2.46,4.32,.48,2-.29,4.27-.61,6.23s-.43,3.91,.51,5.57c.93,1.66,2.35,2.41,4.03,2.93,1.69,.53,3.32,.54,5.09,.56,3.09,.04,6.26-.94,9.34-1.07,3.08-.13,5.94,.17,8.72,1.42,4.28,6.85,3.84,18.25,3.04,24.67-.8,6.42-2.44,9.44,5.81,4.6,8.26-4.84,25.19-15.98,35.04-22.28,3.54-2.27,3.77-6.24,1.64-9.44,0-.03,0,0,0,0-6.32-10.75-4.21-20.6,1.03-31.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227.03,39.57c.25-1.12,.44-2.26,.57-3.43,1.82-16.95-10.45-32.17-27.4-33.99-14.69-1.58-28.08,7.43-32.57,20.9-4.45-3.88-10.08-6.48-16.39-7.16-16.38-1.76-31.09,10.09-32.85,26.48-.17,1.62-.21,3.23-.13,4.8-8.61-.52-16.19,5.8-17.12,14.46h0c-.96,8.92,5.5,16.93,14.42,17.89l4.52,.49c.54,12.38,10.05,22.85,22.75,24.22,7.65,.82,14.86-1.83,20.08-6.69,4.93,7.06,12.77,12.04,22.01,13.03,14.41,1.55,27.57-7.09,32.31-20.13l2.85,.31c14.19,1.52,26.92-8.74,28.45-22.93,1.47-13.7-8.06-26.05-21.49-28.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 124.22,
    cy: 108.86,
    r: 4.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 110.83,
    cy: 116.52,
    r: 3.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.75,31.28c0,9.77-4.56,18.47-11.67,24.09-6.14,4.86-9.63,8.92-9.63,16.75v6.8h-18.78v-6.76c0-7.84-3.48-11.93-9.63-16.8-7.11-5.62-11.67-14.32-11.67-24.08,0-16.94,13.56-30.59,30.5-30.69,17.03-.1,30.87,13.68,30.87,30.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 190.67,
    cy: 39.75,
    r: 3.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 193.93,
    y1: 89.82,
    x2: 193.93,
    y2: 39.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 203.46,
    cy: 39.75,
    r: 3.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 200.2,
    y1: 89.82,
    x2: 200.2,
    y2: 39.75
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 183.88,
    y: 77.26,
    width: 26.36,
    height: 4.33,
    rx: 2.17,
    ry: 2.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 183.88,
    y: 81.42,
    width: 26.36,
    height: 4.33,
    rx: 2.17,
    ry: 2.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.61,85.78l-1.15,5.1c-.39,1.75-1.95,2.99-3.74,2.99h-11.31c-1.79,0-3.34-1.24-3.74-2.99l-1.15-5.1h21.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.97,
    y1: 47.28,
    x2: 146.31,
    y2: 76.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "161.37 71.6 171.94 61.72 161.37 51.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "140.91 71.6 130.34 61.72 140.91 51.85"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkInterest);
export default __webpack_public_path__ + "static/media/sparkInterest.1a93727a9de1b7fc163406222422e241.svg";
export { ForwardRef as ReactComponent };